import gql from 'graphql-tag';

export const ADD_DIMENSION = gql`
mutation($input: AddRemoveDimensionToAccountInput!) {
    addDimension(input: $input) {
      account {
        id
        assessmentSections {
          behaviorSection {
            dimensions {
              id
              name
              displayName
            }
          }
          cognitiveSection {
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            dimensions {
              id
              name
              displayName
            }
          }
        }
      }
    }
  }
  
`;

export const REMOVE_DIMENSION = gql`
mutation($input: AddRemoveDimensionToAccountInput!) {
    removeDimension(input: $input) {
      account {
        id
        assessmentSections {
          behaviorSection {
            dimensions {
              id
              name
              displayName
            }
          }
          cognitiveSection {
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            dimensions {
              id
              name
              displayName
            }
          }
        }
      }
    }
  }
  
`;

export const ADD_ABILITY = gql`
mutation($input: AddRemoveAbilityToAccountInput!) {
  addAbility(input: $input) {
    account {
      id
      assessmentSections {
        behaviorSection {
          dimensions {
            id
            name
            displayName
          }
        }
        cognitiveSection {
          dimensions {
            id
            name
            displayName
          }
        }
        interestsSection {
          dimensions {
            id
            name
            displayName
          }
        }
      }
    }
  }
}

`;

export const REMOVE_ABILITY = gql`
mutation($input: AddRemoveAbilityToAccountInput!) {
  removeAbility(input: $input) {
    account {
      id
      assessmentSections {
        behaviorSection {
          dimensions {
            id
            name
            displayName
          }
        }
        cognitiveSection {
          dimensions {
            id
            name
            displayName
          }
        }
        interestsSection {
          dimensions {
            id
            name
            displayName
          }
        }
      }
    }
  }
}

`;

export const ADD_DISTORTION = gql`
  mutation($input: AddRemoveDistortionToAccountInput!) {
    addDistortion(input: $input) {
      account {
        id
        assessmentSections {
          behaviorSection {
            dimensions {
              id
              name
              displayName
            }            
          }
          cognitiveSection {
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            dimensions {
              id
              name
              displayName
            }
          }
        }
      }
    }
  }

`;

export const REMOVE_DISTORTION = gql`
mutation($input: AddRemoveDistortionToAccountInput!) {
    removeDistortion(input: $input) {
      account {
        id
        assessmentSections {
          behaviorSection {
            dimensions {
              id
              name
              displayName
            }
          }
          cognitiveSection {
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            dimensions {
              id
              name
              displayName
            }
          }
        }
      }
    }
  }
  
`;

export const ADD_INTERESTS = gql`
  mutation($input: AddRemoveInterestsToAccountInput!) {
    addInterests(input: $input) {
      account {
        id
        assessmentSections {
          behaviorSection {
            dimensions {
              id
              name
              displayName
            }
          }
          cognitiveSection {
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            dimensions {
              id
              name
              displayName
            }
          }
        }
      }
    }
  }

`;

export const REMOVE_INTERESTS = gql`
  mutation($input: AddRemoveInterestsToAccountInput!) {
  removeInterests(input: $input) {
    account {
      id
      assessmentSections {
        behaviorSection {
          dimensions {
            id
            name
            displayName
          }
        }
        cognitiveSection {
          dimensions {
            id
            name
            displayName
          }
        }
        interestsSection {
          dimensions {
            id
            name
            displayName
          }
        }
      }
    }
  }
}

`;
